import { HsMatrix4 } from '../../math-new/objects/matrix4.class';
import { HsQuaternion } from '../../math-new/objects/quaternion.class';
import { hsMergeGeometries } from '../geometry-utils/merge-geometries.function';
import type { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';
import { hsGenerateCylinderGeometryData } from './generate-cylinder-geometry-data.function';
import { hsGenerateSphereGeometryData } from './generate-sphere-function';

export function hsGenerateCapsuleGeometryData(quality: number = 12): HsRegularGeometryData {
  const cylinderData: HsRegularGeometryData = hsGenerateCylinderGeometryData(quality, false, false);
  const sphereData: HsRegularGeometryData = hsGenerateSphereGeometryData(quality, 0.5);
  const cylinderDataWithMatrix: [HsRegularGeometryData, HsMatrix4] = [cylinderData, HsMatrix4.makeIdentityMatrix()];
  const direction1: HsQuaternion = HsQuaternion.makeFromAxisAndAngle([1, 0, 0], 0);
  const rotation1: HsMatrix4 = HsMatrix4.compose([0, 1, 0], direction1.values, [1, 1, 1]);
  const sphereDataWithMatrix1: [HsRegularGeometryData, HsMatrix4] = [sphereData, rotation1];
  const direction2: HsQuaternion = HsQuaternion.makeFromAxisAndAngle([1, 0, 0], -Math.PI);
  const rotation2: HsMatrix4 = HsMatrix4.compose([0, -1, 0], direction2.values, [1, 1, 1]);
  const sphereDataWithMatrix2: [HsRegularGeometryData, HsMatrix4] = [sphereData, rotation2];
  cylinderDataWithMatrix;
  const data: HsRegularGeometryData = hsMergeGeometries([
    cylinderDataWithMatrix,
    sphereDataWithMatrix1,
    sphereDataWithMatrix2,
  ]);
  return data;
}
